import * as React from 'react';
import { cn } from '@/lib/utils';

export interface HStackProps extends React.HTMLAttributes<HTMLDivElement> {
  spacing?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 8
    | 10
    | 12
    | 16
    | 20
    | 24
    | 32
    | 40
    | 48
    | 56
    | 64
    | string;
  justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch';
  wrap?: boolean;
}

const HStack = React.forwardRef<HTMLDivElement, HStackProps>(
  (
    {
      className,
      spacing = 2,
      justify = 'center',
      align = 'center',
      wrap = false,
      ...props
    },
    ref
  ) => {
    const justifyClasses = {
      start: 'justify-start',
      end: 'justify-end',
      center: 'justify-center',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    };

    const alignClasses = {
      start: 'items-start',
      end: 'items-end',
      center: 'items-center',
      baseline: 'items-baseline',
      stretch: 'items-stretch',
    };

    const spacingClass =
      typeof spacing === 'string' ? spacing : `gap-${spacing}`;
    const wrapClass = wrap ? 'flex-wrap' : 'flex-nowrap';

    return (
      <div
        className={cn(
          'flex flex-row items-center',
          spacingClass,
          justifyClasses[justify],
          alignClasses[align],
          wrapClass,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

HStack.displayName = 'HStack';

export { HStack };
